import React from "react";

import { Grid, Skeleton } from "@mui/material";

const TableLoading = () => {
  return (
    <>
      {Array(4)
        .fill(0)
        .map((_, index) => {
          return (
            <Grid container spacing={3} key={index}>
              <Grid item xs={3}>
                <Skeleton variant="text" height="30px" />
              </Grid>
              <Grid item xs={9}>
                <Skeleton variant="text" height="30px" />
              </Grid>
            </Grid>
          );
        })}
    </>
  );
};

export default TableLoading;
